function defaults() {
  return {
    inactivity_timeout: 1800000,
    login_type: 'session', // Options: ['session', 'token']
    footer: true,
  };
}

let config = {};

export function install_settings() {
  config = {
    ...defaults(),
    ...(window.LOCAL_SETTINGS || {}),
  };
}

export function get_settings() {
  return config || {};
}
